import Backbone from 'backbone';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import template from './importTaskItem.pug';

export class ImportTaskItemContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
    isMCC,
    recommendationService,
    newI18n,
    taskItemId,
    budgetAdjustmentOption,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.campaignId = targetId;
    this.isMCC = isMCC;
    this.campaignDeliveryStatusTitle = '';
    this.campaignDeliveryStatus = '';
    this.campaignType = '';
    this.campaignBudget = '';
    this.campaignBiddingType = '';
    this.eligibleStatusIcon = false;
    this.showStatusIcon = false;
    this.recommendationService = recommendationService;
    this.newI18n = newI18n;
    this.taskItemId = taskItemId;
    this.budgetAdjustmentOption = budgetAdjustmentOption;
  }


  render({
    showDeliveryStatusPopup,
  }) {
    const {
      deps,
      i18n,
      newI18n,
      taskItemId,
      budgetAdjustmentOption,
    } = this;

    deps.jsdata.TaskItem.findAll({
      query: {
        $filter: deps.importScheduleConstants.FILTER_ALL_BUT_DELETED,
      },
    }).then((response) => {
      if (response.length && response.length > 0) {
        const taskItem = _.filter(response, item => item.Id === taskItemId);
        if (taskItem.length > 0) {
          const status = taskItem[0].State === 'Active' ? newI18n.getString(_TL_('Enabled')) : newI18n.getString(_TL_('Paused'));

          const creator = taskItem[0].ModifiedBy && taskItem[0].ModifiedBy.Name;
          const dateTime = dateUtil.format(new Date(taskItem[0].ModifiedAt), 'dddd, MMMM d, yyyy', config.get('culture'));
          const time = dateUtil.format(new Date(taskItem[0].ModifiedAt), 'hh:mm:ss tt', config.get('culture'));
          const createdBy = `${creator}<div>${dateTime}, ${time}</div>`;

          const when = deps.importFreqColDataToTemplate(taskItem[0], i18n);
          const importedCampaigns = taskItem[0].AdWordsImportContext.CampaignIds.length;
          const limitedByBudgetCampaigns = budgetAdjustmentOption.BudgetConstrainedCampaignsCount;

          this.$el.html(template({
            status: `<span id="title">${newI18n.getString(_TL_('Status'))}: </span>${status}`,
            createdBy: `<span id="title">${newI18n.getString(_TL_('Created by'))}: </span>${createdBy}`,
            when: `<span id="title">${newI18n.getString(_TL_('When'))}: </span>${when}`,
            importedCampaigns: `<span id="title">${newI18n.getString(_TL_('Imported campaigns'))}: </span>${importedCampaigns}`,
            limitedByBudgetCampaigns: `<span id="title">${newI18n.getString(_TL_('Campaigns limited by budget'))}: </span>${limitedByBudgetCampaigns}`,
          }));

          showDeliveryStatusPopup(this.el.outerHTML);
        }
      }
    });
    return this;
  }
}
